import { render, staticRenderFns } from "./bingx.vue?vue&type=template&id=528d8a2f&scoped=true&"
import script from "./bingx.vue?vue&type=script&lang=js&"
export * from "./bingx.vue?vue&type=script&lang=js&"
import style0 from "./bingx.vue?vue&type=style&index=0&id=528d8a2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d8a2f",
  null
  
)

export default component.exports